<onyx-information-heading>
  {{ 'labels.route' | translate }}

  <ng-container actions>
    @if (planRouteState(); as state) {
      <onyx-icon-button
        variant="transparent"
        color="gray"
        [size]="32"
        icon="route-outlined"
        [circle]="true"
        [disabled]="state.disabled"
        [onyxTooltip]="state.tooltip"
        (click)="planRoute()"
      ></onyx-icon-button>
    }
  </ng-container>
</onyx-information-heading>

<div class="route">
  @let loadingAddress = loadingPoints().point.address;
  @let unloadingAddress = unloadingPoints().point.address;

  <onyx-data-widget
    [headingIcon]="{ name: 'loading-outlined', size: 20, color: 'black' }"
    [clickable]="true"
    (click)="openPointModal('loading')"
  >
    <onyx-address
      heading
      [address]="loadingAddress"
      format="city-flag"
    ></onyx-address>

    <div class="list">
      <span class="f-muted">{{ 'labels.from' | translate }}</span>

      @if (loadingPoints().point.timeWindows.windows; as timeWindows) {
        @let window = timeWindows[0];
        <span>
          {{ window.time ?? window.timeRange?.from | onyxTime }} ·
          {{ window.date | onyxDate: 'date-dot' }} ·
        </span>

        <span class="f-muted">
          {{ 'labels.loadings' | translate }}
        </span>
      }

      <span>{{ loadingPoints().count }}</span>
    </div>
  </onyx-data-widget>

  <onyx-data-widget
    [headingIcon]="{ name: 'unloading-outlined', size: 20, color: 'black' }"
    [clickable]="true"
    (click)="openPointModal('unloading')"
  >
    <onyx-address
      heading
      [address]="unloadingAddress"
      format="city-flag"
    ></onyx-address>

    <div class="list">
      <span class="f-muted">{{ 'labels.to' | translate }}</span>

      @if (unloadingPoints().point.timeWindows.windows; as timeWindows) {
        @let window = timeWindows[timeWindows.length - 1];
        <span>
          {{ window.time ?? window.timeRange?.from | onyxTime }} ·
          {{ window.date | onyxDate: 'date-dot' }} ·
        </span>

        <span class="f-muted">
          {{ 'labels.unloadings' | translate }}
        </span>
      }

      <p>{{ unloadingPoints().count }}</p>
    </div>
  </onyx-data-widget>
</div>
